(function () {
  var SYNC_DELAYS = [0, 200, 600, 1200, 2500, 5000, 8000];

  function withSwym(cb, attempt) {
    attempt = attempt || 0;
    if (window._swat) {
      cb(window._swat);
      return;
    }
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(cb);
    if (attempt < 40) {
      setTimeout(function () {
        if (window._swat) cb(window._swat);
        else withSwym(cb, attempt + 1);
      }, 250);
    }
  }

  function toDisplayPrice(raw) {
    var n = parseFloat(raw);
    if (!isFinite(n)) return undefined;
    return n >= 100 ? n / 100 : n;
  }

  function normalizeUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function setWishState(btn, active) {
    btn.classList.toggle('is-active', !!active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  /* Même payload partout (lookbook / collection / PDP) — pas de branche SwymPageData. */
  function buildPayload(btn) {
    var payload = {
      epi: parseInt(btn.getAttribute('data-variant-id'), 10),
      empi: parseInt(btn.getAttribute('data-product-id'), 10),
      du: normalizeUrl(btn.getAttribute('data-url') || '')
    };

    var dt = btn.getAttribute('data-product-title');
    var iu = btn.getAttribute('data-product-image');
    var pr = toDisplayPrice(btn.getAttribute('data-product-price'));
    if (dt) payload.dt = dt;
    if (iu) payload.iu = normalizeUrl(iu);
    if (pr != null) payload.pr = pr;
    if (btn.getAttribute('data-product-available') === 'false') payload.stk = 0;

    var variants = window.SwymProductVariants;
    if (variants && variants[payload.epi]) {
      var v = variants[payload.epi];
      if (v.epi) payload.epi = parseInt(v.epi, 10);
      if (v.iu) payload.iu = normalizeUrl(v.iu);
      if (v.pr != null) {
        var vPr = toDisplayPrice(v.pr);
        if (vPr != null) payload.pr = vPr;
      }
      if (v.stk != null) payload.stk = v.stk ? 1 : 0;
    }

    return payload;
  }

  function isInWishlist(swat, empi, cb) {
    if (!swat || !swat.fetch) { cb(false); return; }
    swat.fetch(function (items) {
      var found = (items || []).some(function (it) { return it && String(it.empi) === String(empi); });
      cb(found);
    });
  }

  function markFromWishlist(scope) {
    withSwym(function (swat) {
      if (!swat.fetch) return;
      swat.fetch(function (items) {
        var inList = {};
        (items || []).forEach(function (it) { if (it && it.empi) inList[String(it.empi)] = 1; });
        (scope || document).querySelectorAll('[data-stella-wishlist]').forEach(function (btn) {
          var empi = btn.getAttribute('data-product-id');
          if (!empi) return;
          setWishState(btn, !!inList[empi]);
        });
      });
    });
  }

  function addToWishlist(swat, payload, btn, scope) {
    var addFn = swat.addToWishList || swat.AddToWishList;
    if (!addFn) return;
    addFn.call(swat, payload, function () {
      isInWishlist(swat, payload.empi, function (ok) {
        setWishState(btn, ok);
        markFromWishlist(scope);
      });
    }, function () {
      isInWishlist(swat, payload.empi, function (ok) { setWishState(btn, ok); });
    });
  }

  function removeFromWishlist(swat, payload, btn, scope) {
    var rmFn = swat.removeFromWishList || swat.RemoveFromWishList;
    if (!rmFn) return;
    rmFn.call(swat, payload, function () {
      isInWishlist(swat, payload.empi, function (ok) {
        setWishState(btn, ok);
        markFromWishlist(scope);
      });
    }, function () {
      isInWishlist(swat, payload.empi, function (ok) { setWishState(btn, ok); });
    });
  }

  function handleWishClick(btn) {
    if (btn.classList.contains('is-busy')) return;

    var payload = buildPayload(btn);
    if (!payload.epi || !payload.empi || !payload.du) return;

    var wasActive = btn.classList.contains('is-active');
    btn.classList.add('is-busy');
    setWishState(btn, !wasActive);

    withSwym(function (swat) {
      if (wasActive) {
        removeFromWishlist(swat, payload, btn, document);
      } else {
        addToWishlist(swat, payload, btn, document);
      }
      setTimeout(function () { btn.classList.remove('is-busy'); }, 600);
    });
  }

  function bindWishlists(scope) {
    markFromWishlist(scope);
  }

  function syncPdpVariant(variantId) {
    if (!variantId) return;
    document.querySelectorAll('.stellaPdpWishSlot, .stellaPdpWish[data-stella-wishlist]').forEach(function (el) {
      if (el.classList.contains('stellaPdpWish')) {
        el.setAttribute('data-variant-id', String(variantId));
      } else {
        el.setAttribute('data-variant-id', String(variantId));
        var heart = el.querySelector('.stellaPdpWish');
        if (heart) heart.setAttribute('data-variant-id', String(variantId));
      }
      var variants = window.SwymProductVariants;
      if (variants && variants[variantId]) {
        var v = variants[variantId];
        var target = el.classList.contains('stellaPdpWish') ? el : el.querySelector('.stellaPdpWish');
        if (target) {
          if (v.pr != null) target.setAttribute('data-product-price', String(v.pr));
          if (v.iu) target.setAttribute('data-product-image', normalizeUrl(v.iu));
          if (v.stk != null) target.setAttribute('data-product-available', v.stk ? 'true' : 'false');
        }
      }
    });
    markFromWishlist(document);
  }

  if (!window.__stellaWishClickBound) {
    window.__stellaWishClickBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest('[data-stella-wishlist]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      handleWishClick(btn);
    }, true);
  }

  window.stellaBindWishlists = bindWishlists;
  window.stellaSyncPdpWishlistVariant = syncPdpVariant;

  bindWishlists(document);
  document.addEventListener('shopify:section:load', function (e) {
    bindWishlists(e.target || document);
  });

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.name) return;
    if (el.name === 'id' || el.classList.contains('product-variant-id')) {
      syncPdpVariant(el.value);
    }
  });

  withSwym(function (swat) {
    if (swat.evtLayer && swat.JSEvents && swat.JSEvents.variantChanged) {
      swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, function (evt) {
        var d = evt && evt.detail && evt.detail.d;
        var vid = d && d.variant && d.variant.id;
        if (vid) syncPdpVariant(vid);
      });
    }
    if (swat.evtLayer) {
      ['addedToWishlist', 'removedFromWishlist', 'wishlistUpdated'].forEach(function (evtKey) {
        var evtName = swat.JSEvents && swat.JSEvents[evtKey];
        if (!evtName) return;
        swat.evtLayer.addEventListener(evtName, function () {
          markFromWishlist(document);
        });
      });
    }
  });

  ['swym:addedtowishlist', 'swym:removedfromwishlist', 'swym:wishlist-updated'].forEach(function (evtName) {
    document.addEventListener(evtName, function () {
      markFromWishlist(document);
    });
  });

  SYNC_DELAYS.forEach(function (t) {
    setTimeout(function () { bindWishlists(document); }, t);
  });
})();
